import store from "../store";

const CUSTOMER_PREFIX = "/connect/aluno";
// Telas liberadas mesmo com o cadastro incompleto.
const ALLOWED_WHEN_PENDING = [
  `${CUSTOMER_PREFIX}/perfil`,
  `${CUSTOMER_PREFIX}/completar-informacoes`,
];

export default async (to, from, next) => {
  if (to.name != from.name) window.scrollTo(0, 0);

  const requiredAuth = to.meta.authRequired ?? false;
  const preventAuth = to.meta.preventAuth ?? false;

  const authenticated = !!store.getters.token;

  if (requiredAuth && !authenticated) return next("/connect");
  if (preventAuth && !authenticated) return next("/connect");

  // Bloqueia o uso da plataforma por alunos com cadastro incompleto (inseridos
  // pelo admin, sem nivelamento/preferencias) ate completarem as informacoes.
  const user = store.getters.user;
  if (
    authenticated &&
    store.getters.module === "aluno" &&
    to.path.startsWith(CUSTOMER_PREFIX) &&
    user &&
    user.pendingInfo &&
    !ALLOWED_WHEN_PENDING.includes(to.path)
  ) {
    return next(`${CUSTOMER_PREFIX}/completar-informacoes`);
  }

  // Aluno solo (preference ALONE = 1) nao tem fluxo de turmas/match: redireciona
  // qualquer acesso direto a rota de Turmas para os modulos.
  if (
    authenticated &&
    store.getters.module === "aluno" &&
    to.path === `${CUSTOMER_PREFIX}/turmas` &&
    user &&
    user.preference === 1
  ) {
    return next(`${CUSTOMER_PREFIX}/curso`);
  }

  document.title = to.name + "- Pitch Connect";

  next();
};
